import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createSchool, fetchStates } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Buttons.css';
import './_Input.css';
import './_Modal.css';

const CreateSchoolModal = ({ isOpen, onClose, onSchoolCreated }) => {
    const [name, setName] = useState('');
    const [sevpCode, setSevpCode] = useState('');
    const [state, setState] = useState('');
    const [states, setStates] = useState([]);
    const [error, setError] = useState('');

    useEffect(() => {
        const getStates = async () => {
            try {
                const fetchedStates = await fetchStates();
                setStates(fetchedStates.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };

        if (isOpen) {
            getStates();
        }
    }, [isOpen]);

    const handleCreate = async () => {
        setError('');
        if (sevpCode.length !== 15) {
            setError('SEVP Code must be 15 characters long.');
            return;
        }

        try {
            await createSchool(name, sevpCode, parseInt(state, 10));
            onSchoolCreated();
            onClose();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    if (!isOpen) {
        return null;
    }

    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Create School</h2>
                {error && <p className="error">{error}</p>}
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="School Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        placeholder="SEVP Code"
                        value={sevpCode}
                        onChange={(e) => setSevpCode(e.target.value)}
                        maxLength="15"
                    />
                </div>
                <div className="form-group">
                    <select value={state} onChange={(e) => setState(e.target.value)}>
                        <option value="" disabled>Select State</option>
                        {states.map(state => (
                            <option key={state.id} value={state.id}>{state.full_name}</option>
                        ))}
                    </select>
                </div>
                <div className="actions-centered">
                    <button onClick={onClose} className='cancel-button text-button'>Cancel</button>
                    <button onClick={handleCreate} className='submit-button text-button'>Create</button>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default CreateSchoolModal;